<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">مدیریت سطح مشتریان</h5>
        <button
          :disabled="disabled"
          type="button"
          @click="submitChanges"
          class="btn btn-success"
        >
          ثبت تغییرات
        </button>
      </div>
      <div class="card-body">
        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          small
          v-if="items && items.length"
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(title)="data">
            <b-form-input type="text" v-model="data.item.title" />
          </template>
          <template v-slot:cell(min_score)="data">
            <b-form-input type="number" v-model="data.item.min_score" />
          </template>
          <template v-slot:cell(max_score)="data">
            <b-form-input type="number" v-model="data.item.max_score" />
          </template>
          <template v-slot:cell(color)="data">
            <b-form-input type="text" v-model="data.item.color" />
          </template>
          <template v-slot:cell(permanent_purchase_discount)="data">
            <b-form-input
              type="number"
              v-model="data.item.permanent_purchase_discount"
            />
          </template>
          <template v-slot:cell(coupon_discount_percentage)="data">
            <b-form-input
              type="number"
              v-model="data.item.coupon_discount_percentage"
            />
          </template>
          <template v-slot:cell(birthdate_discount)="data">
            <b-form-input
              type="number"
              v-model="data.item.birthdate_discount"
            />
          </template>
          <template v-slot:cell(free_shipping)="data">
            <b-form-input type="number" v-model="data.item.free_shipping" />
          </template>
        </b-table>
        <div v-else class="alert alert-info">
          موردی یافت نشد
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import LevelSettingsImpl from "@@/core/pages/customerClub/clubSettings/levelSettings/LevelSettingsImpl.js";
export default {
  extends: LevelSettingsImpl,
};
</script>
